import { formatTo2DigitsDate } from '../../utils/times'

export const fields = [
  {
    name: 'posicao',
    title: 'Posição',
    titleClass: 'text-center',
    dataClass: 'text-center'
  },
  {
    name: 'cns',
    title: 'Nº Cartão SUS',
    titleClass: 'text-center',
    dataClass: 'text-center'
  },
  {
    name: '__slot:gravidade',
    title: 'Gravidade',
    titleClass: 'text-center',
    dataClass: 'text-center'
  }
  // {
  //   name: 'dtsolicitacao',
  //   title: 'Data Solicitação',
  //   titleClass: 'text-center',
  //   dataClass: 'text-center',
  //   callback: value => {
  //     if (value) {
  //       const date = new Date(value)

  //       return formatTo2DigitsDate(date)
  //     }

  //     return value
  //   }
  // }
]

export const fieldsAgendados = [
  {
    name: 'cns',
    title: 'Nº Cartão SUS',
    titleClass: 'text-center',
    dataClass: 'text-center'
  },
  {
    name: '__slot:gravidade',
    title: 'Gravidade',
    titleClass: 'text-center',
    dataClass: 'text-center'
  },
  // {
  //   name: 'dtsolicitacao',
  //   title: 'Data Solicitação',
  //   dataClass: 'text-center',
  //   titleClass: 'text-center',
  //   callback: value => {
  //     if (value) {
  //       const date = new Date(value)

  //       return formatTo2DigitsDate(date)
  //     }

  //     return '-----'
  //   }
  // },
  {
    name: '__slot:agendado',
    title: 'Data Agendamento',
    titleClass: 'text-center',
    dataClass: 'text-center'
  },
  // {
  //   name: 'dtatendimento',
  //   title: 'Data atendimento',
  //   dataClass: 'text-center',
  //   titleClass: 'text-center',
  //   callback: value => {
  //     if (value) {
  //       const date = new Date(value)

  //       return formatTo2DigitsDate(date)
  //     }

  //     return '-----'
  //   }
  // },
  // {
  //   name: 'situacao',
  //   title: 'Situação'
  // },
  {
    name: 'unidade_destino',
    title: 'Unidade'
  },
  {
    name: 'endereco',
    title: 'Endereço'
  }
]

export function getGravidadeClass(gravidade) {
  switch (gravidade) {
    case 'Emergência':
      return 'bg-danger'
    case 'Urgência':
      return 'bg-warning'
    case 'Normal':
      return 'bg-success'
    default:
      return 'bg-warning'
  }
}

export function getProximidadeData(dtagendamento) {
  const atual = new Date()
  const agendado = new Date(dtagendamento)
  atual.setHours(0, 0, 0, 0)

  if (atual > agendado) {
    return
  }

  const dias = (agendado - atual) / (1000 * 60 * 60 * 24)

  switch (true) {
    case dias > 30:
      return 'bg-success'
    case dias > 7:
      return 'bg-warning'
    default:
      return 'bg-danger'
  }
}



// WEBPACK FOOTER //
// ./src/components/ProcedimentosSaude/datatableFields.js